import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { request } from "@/js/http/http_request";
import { isAdminNotConsultant, hasRole } from "@/js/http/auth.js";
import { formatPrice, getSymbolCurrency } from "@/js/currency/currencies.js";
import { getErrorData } from "@/js/forms.js";
import { expeditionMethodList, listUserGroups, pricePostingUsaProConstants } from "@/js/lists.ts";
import { setFilters, getFilters } from "@/js/filter/filter.js";
import { formRules } from "@/js/form_rules.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import LogisticCostDialog from "@/components/shipping/LogisticCostDialog.vue";
import ScheduledLogisticCostsModal from "@/components/shipping/ScheduledLogisticCostsModal.vue";
export default {
  name: "logisticCostList",
  components: {
    Confirm: Confirm,
    LogisticCostDialog: LogisticCostDialog,
    ScheduledLogisticCostsModal: ScheduledLogisticCostsModal
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      canScheduleModifications: false,
      displayBy: [{
        id: 1,
        name: "Shipping type"
      }, {
        id: 2,
        name: "Departure from"
      }, {
        id: 3,
        name: "Arrival to"
      }],
      headers: [{
        text: "Quantity min (bottles)",
        value: "qty_min",
        align: "center"
      }, {
        text: "Quantity max (bottles)",
        value: "qty_max",
        align: "center"
      }, {
        text: "ETA min (hours)",
        value: "eta_min_hours",
        align: "center"
      }, {
        text: "ETA max (hours)",
        value: "eta_max_hours",
        align: "center"
      }, {
        text: "Price (€) per bottle",
        value: "shipping_price_eur_per_bottle",
        align: "center"
      }, {
        text: "",
        value: "action",
        align: "center"
      }],
      items: [],
      panelExpansions: [],
      formSearch: {
        sortBy: 1,
        expeditionMethodsId: null,
        countriesDepartureId: null,
        countriesArrivalId: null
      },
      currentItem: null,
      titleModal: "",
      logisticCostDialogShown: false,
      managedExceptions: {
        warning: {
          logistic_cost_already_deleted: "The logistic cost is already deleted.",
          logistic_cost_already_exists: "The logistic cost already exists."
        }
      },
      listCountries: [],
      listStates: [],
      listCountriesArrival: [],
      listStatesArrival: [],
      listCountriesForDialog: [],
      listStatesForDialog: [],
      isScheduledLogisticCostsModalShown: false,
      rules: formRules,
      expeditionMethodList: expeditionMethodList,
      listUserGroups: listUserGroups,
      pricePostingUsaProConstants: pricePostingUsaProConstants
    };
  },
  computed: {
    isSaveAllAvailable: function isSaveAllAvailable() {
      return this.items.some(function (x) {
        return x.isSaveAvailable;
      });
    },
    isSavingAll: function isSavingAll() {
      return this.items.some(function (x) {
        return x.isSaving;
      });
    },
    getUserGroups: function getUserGroups() {
      return ["HORECA", "USER"];
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var filters;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!isAdminNotConsultant(_this2.loggedUserData) || !hasRole(process.env.VUE_APP_ROLES_MANAGE_SHIPPING))) {
              _context.next = 3;
              break;
            }
            _this2.$router.push({
              name: "userHome"
            });
            return _context.abrupt("return");
          case 3:
            _this2.canScheduleModifications = hasRole(process.env.VUE_APP_ROLES_SCHEDULE_SHIPPING_MODIFICATIONS);
            filters = getFilters();
            if (filters !== null && filters !== void 0 && filters.logisticCosts) {
              _this2.formSearch = _objectSpread(_objectSpread({}, _this2.formSearch), filters.logisticCosts);
            }
            _context.next = 8;
            return _this2.fetchCountries();
          case 8:
            _context.next = 10;
            return _this2.fetchCountriesArrival();
          case 10:
            _context.next = 12;
            return _this2.fetchLogisticCosts();
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchLogisticCosts: function fetchLogisticCosts() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this3;
              _this3.panelExpansions = [];
              setFilters(function (state) {
                return _objectSpread(_objectSpread({}, state), {}, {
                  logisticCosts: _this3.formSearch
                });
              });
              _this3.$EventBus.$emit("loading", true);
              _context2.next = 6;
              return request("/v1/logistic/costs", "post", _this3.formSearch, true, "api").then(function (response) {
                _this.items = response.data.value.items.map(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    expeditionMethodDetail: _this.getExpeditionMethod(x.expedition_method),
                    departure: _this.formatLocation(x.continent_iso_2_departure, x.label_country_departure, x.label_state_departure, x.id_country_departure),
                    arrival: _this.formatLocation(x.continent_iso_2_arrival, x.label_country_arrival, x.label_state_arrival, x.id_country_arrival),
                    isSaveAvailable: false,
                    isSaving: false
                  });
                });
              }).catch(function (e) {
                _this.$toasted.show("Unable to load the logistic costs.", {
                  type: "error"
                });
              });
            case 6:
              _this3.$EventBus.$emit("loading", false);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getExpeditionMethod: function getExpeditionMethod(id) {
      return this.expeditionMethodList.find(function (x) {
        return x.id == id;
      });
    },
    formatLocation: function formatLocation(continent, country, state, id_country) {
      var format = continent !== null && continent !== void 0 ? continent : country;
      if (country && continent) {
        format += " - " + country;
      }
      if (state) {
        format += " - " + state;
      } else if (this.listStates.some(function (x) {
        return x.id_country == id_country;
      })) {
        format += " (default)";
      }
      return format;
    },
    expeditionMethods: function expeditionMethods() {
      var _this4 = this;
      var departure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var arrival = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var result = expeditionMethodList;
      if (this.formSearch.expeditionMethodsId && this.formSearch.expeditionMethodsId.length > 0) {
        result = expeditionMethodList.filter(function (x) {
          return _this4.formSearch.expeditionMethodsId.includes(x.id);
        });
      }
      var _this = this;
      result = result.map(function (x) {
        return _objectSpread(_objectSpread({}, x), {}, {
          count: _this.countItemsForExpeditionMethod(x.id, departure, arrival)
        });
      });
      return result;
    },
    countItemsForExpeditionMethod: function countItemsForExpeditionMethod(expeditionId, departure, arrival) {
      if (this.formSearch.sortBy === 1) {
        return this.items.filter(function (x) {
          return x.expedition_method === expeditionId && x.id_logistic_cost;
        }).length;
      } else {
        return this.items.filter(function (x) {
          return x.id_logistic_cost && x.expedition_method === expeditionId && x.departure === departure && x.arrival === arrival;
        }).length;
      }
    },
    getGroupResult: function getGroupResult(group) {
      var result = [];
      for (var _i = 0, _Object$entries = Object.entries(group); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        result.push({
          id: key,
          text: key,
          item: value[0],
          count: value.filter(function (x) {
            return x.id_logistic_cost;
          }).length
        });
      }
      return result;
    },
    firstLevel: function firstLevel() {
      if (this.formSearch.sortBy === 1) {
        return this.expeditionMethods();
      }
      if (this.formSearch.sortBy === 2) {
        return this.getGroupResult(this.items.filter(function (x) {
          return x.continent_iso_2_departure;
        }).group(function (_ref) {
          var departure = _ref.departure;
          return departure;
        }));
      }
      if (this.formSearch.sortBy === 3) {
        return this.getGroupResult(this.items.filter(function (x) {
          return x.continent_iso_2_arrival;
        }).group(function (_ref2) {
          var arrival = _ref2.arrival;
          return arrival;
        }));
      }
      return [];
    },
    secondLevel: function secondLevel(firstValue) {
      if (this.formSearch.sortBy === 1) {
        return this.getGroupResult(this.items.filter(function (x) {
          return x.expedition_method === firstValue && x.continent_iso_2_departure;
        }).group(function (_ref3) {
          var departure = _ref3.departure;
          return departure;
        }));
      }
      if (this.formSearch.sortBy === 2) {
        return this.getGroupResult(this.items.filter(function (x) {
          return x.departure === firstValue && x.continent_iso_2_arrival;
        }).group(function (_ref4) {
          var arrival = _ref4.arrival;
          return arrival;
        }));
      }
      if (this.formSearch.sortBy === 3) {
        return this.getGroupResult(this.items.filter(function (x) {
          return x.arrival === firstValue && x.continent_iso_2_departure;
        }).group(function (_ref5) {
          var departure = _ref5.departure;
          return departure;
        }));
      }
      return [];
    },
    thirdLevel: function thirdLevel(firstValue, secondValue) {
      if (this.formSearch.sortBy === 1) {
        return this.getGroupResult(this.items.filter(function (x) {
          return x.expedition_method === firstValue && x.departure === secondValue && x.continent_iso_2_arrival;
        }).group(function (_ref6) {
          var arrival = _ref6.arrival;
          return arrival;
        }));
      } else if (this.formSearch.sortBy === 2) {
        return this.expeditionMethods(firstValue, secondValue);
      } else if (this.formSearch.sortBy === 3) {
        return this.expeditionMethods(secondValue, firstValue);
      }
      return [];
    },
    dataTable: function dataTable(firstValue, secondValue, thirdValue, user_group) {
      if (this.formSearch.sortBy === 1) {
        return this.items.filter(function (x) {
          return x.expedition_method == firstValue && x.departure == secondValue && x.arrival == thirdValue && x.user_group == user_group;
        });
      }
      if (this.formSearch.sortBy === 2) {
        return this.items.filter(function (x) {
          return x.expedition_method == thirdValue && x.departure == firstValue && x.arrival == secondValue && x.user_group == user_group;
        });
      }
      if (this.formSearch.sortBy === 3) {
        return this.items.filter(function (x) {
          return x.expedition_method == thirdValue && x.departure == secondValue && x.arrival == firstValue && x.user_group == user_group;
        });
      }
    },
    showLogisticCostDialog: function showLogisticCostDialog(value) {
      this.logisticCostDialogShown = value;
    },
    addLocation: function addLocation(continent_iso_2, countryId, stateId, label) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, userGroup, newItem;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this = _this5;
              for (userGroup in _this5.getUserGroups) {
                newItem = _objectSpread(_objectSpread({}, _this.currentItem), {}, {
                  id_logistic_cost: null,
                  user_group: userGroup,
                  qty_min: 0,
                  qty_max: 0,
                  eta_min_hours: 0,
                  eta_max_hours: null,
                  shipping_price_eur_per_bottle: 0.0,
                  isSaving: false,
                  isSaveAvailable: false
                });
                if (_this.titleModal == "Departure") {
                  newItem = _objectSpread(_objectSpread({}, newItem), {}, {
                    continent_iso_2_departure: continent_iso_2,
                    id_country_departure: countryId,
                    id_state_departure: stateId,
                    departure: label
                  });
                  _this.items.push(newItem);
                }
                if (_this.titleModal == "Arrival") {
                  newItem = _objectSpread(_objectSpread({}, newItem), {}, {
                    continent_iso_2_arrival: continent_iso_2,
                    id_country_arrival: countryId,
                    id_state_arrival: stateId,
                    arrival: label
                  });
                  _this.items.push(newItem);
                }
              }
              _this5.showLogisticCostDialog(false);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    countriesForDialog: function countriesForDialog() {
      var _this6 = this;
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.listCountriesForDialog = _toConsumableArray(this.listCountries);
      this.listStatesForDialog = _toConsumableArray(this.listStates);
      var excludes = null;
      var excludeStates = null;
      if (this.titleModal === "Departure") {
        if (this.formSearch.countriesDepartureId && this.formSearch.countriesDepartureId.length > 0) {
          this.listCountriesForDialog = this.listCountries.filter(function (x) {
            return _this6.formSearch.countriesDepartureId.includes(x.id_country);
          });
        }
        if (this.formSearch.sortBy === 1) {
          excludes = Object.keys(this.items.filter(function (x) {
            return x.expedition_method === item.expedition_method;
          }).group(function (_ref7) {
            var id_country_departure = _ref7.id_country_departure;
            return id_country_departure;
          }));
          excludeStates = Object.keys(this.items.filter(function (x) {
            return x.expedition_method === item.expedition_method;
          }).group(function (_ref8) {
            var id_state_departure = _ref8.id_state_departure;
            return id_state_departure;
          }));
        } else if (this.formSearch.sortBy === 2) {
          excludes = Object.keys(this.items.group(function (_ref9) {
            var id_country_departure = _ref9.id_country_departure;
            return id_country_departure;
          }));
          excludeStates = Object.keys(this.items.group(function (_ref10) {
            var id_state_departure = _ref10.id_state_departure;
            return id_state_departure;
          }));
        } else if (this.formSearch.sortBy === 3) {
          excludes = Object.keys(this.items.filter(function (x) {
            return x.id_country_arrival === item.id_country_arrival;
          }).group(function (_ref11) {
            var id_country_departure = _ref11.id_country_departure;
            return id_country_departure;
          }));
          excludeStates = Object.keys(this.items.filter(function (x) {
            return x.id_country_arrival === item.id_country_arrival;
          }).group(function (_ref12) {
            var id_state_departure = _ref12.id_state_departure;
            return id_state_departure;
          }));
        }
      } else if (this.titleModal === "Arrival") {
        this.listCountriesForDialog = _toConsumableArray(this.listCountriesArrival);
        this.listStatesForDialog = _toConsumableArray(this.listStatesArrival);
        if (this.formSearch.countriesArrivalId && this.formSearch.countriesArrivalId.length > 0) {
          this.listCountriesForDialog = this.listCountriesArrival.filter(function (x) {
            return _this6.formSearch.countriesArrivalId.includes(x.id_country);
          });
        }
        if (this.formSearch.sortBy === 1) {
          var hasStates = this.listStatesForDialog.some(function (x) {
            return x.idCountry === item.id_country_arrival;
          });
          var filterCondition = hasStates ? function (x) {
            return x.expedition_method === item.expedition_method && x.id_country_departure === item.id_country_departure && (x.id_state_arrival === item.id_state_arrival || !x.id_state_arrival);
          } : function (x) {
            return x.expedition_method === item.expedition_method && x.id_country_departure === item.id_country_departure;
          };
          excludes = Object.keys(this.items.filter(filterCondition).group(function (_ref13) {
            var id_country_arrival = _ref13.id_country_arrival,
              id_state_arrival = _ref13.id_state_arrival;
            return hasStates ? "".concat(id_country_arrival, "-").concat(id_state_arrival) : id_country_arrival;
          }));
          excludeStates = Object.keys(this.items.filter(function (x) {
            return x.expedition_method === item.expedition_method && x.id_country_departure === item.id_country_departure;
          }).group(function (_ref14) {
            var id_state_arrival = _ref14.id_state_arrival;
            return id_state_arrival;
          }));
        } else if (this.formSearch.sortBy === 2) {
          excludes = Object.keys(this.items.filter(function (x) {
            return x.id_country_departure === item.id_country_departure;
          }).group(function (_ref15) {
            var id_country_arrival = _ref15.id_country_arrival;
            return id_country_arrival;
          }));
          excludeStates = Object.keys(this.items.filter(function (x) {
            return x.id_country_departure === item.id_country_departure;
          }).group(function (_ref16) {
            var id_state_arrival = _ref16.id_state_arrival;
            return id_state_arrival;
          }));
        } else if (this.formSearch.sortBy === 3) {
          excludes = Object.keys(this.items.group(function (_ref17) {
            var id_country_arrival = _ref17.id_country_arrival;
            return id_country_arrival;
          }));
          excludeStates = Object.keys(this.items.group(function (_ref18) {
            var id_state_arrival = _ref18.id_state_arrival;
            return id_state_arrival;
          }));
        }
      }
      if (excludes != null) {
        if (excludeStates != null) {
          this.listStatesForDialog = this.listStatesForDialog.filter(function (x) {
            return !excludeStates.includes(x.id_state.toString());
          });
        }
        excludes = excludes.filter(function (country) {
          return !_this6.listStatesForDialog.some(function (y) {
            return y.id_country == country;
          });
        });
        this.listCountriesForDialog = this.listCountriesForDialog.filter(function (x) {
          return !excludes.includes(x.id_country.toString());
        });
      }
    },
    addCountryDeparture: function addCountryDeparture(item) {
      this.currentItem = item !== null && item !== void 0 ? item : {};
      this.titleModal = "Departure";
      this.countriesForDialog(item);
      if (this.listCountriesForDialog.length > 0) {
        this.showLogisticCostDialog(true);
      } else {
        this.$toasted.show("All filtered countries are already in use.", {
          type: "success"
        });
      }
    },
    addCountryArrival: function addCountryArrival(item) {
      this.currentItem = item !== null && item !== void 0 ? item : {};
      this.titleModal = "Arrival";
      this.countriesForDialog(item);
      if (this.listCountriesForDialog.length > 0) {
        this.showLogisticCostDialog(true);
      } else {
        this.$toasted.show("All filtered countries are already in use.", {
          type: "success"
        });
      }
    },
    addNewLine: function addNewLine(item, user_group) {
      var newItem = _objectSpread(_objectSpread({}, item), {}, {
        user_group: user_group,
        id_logistic_cost: null,
        qty_min: 0,
        qty_max: 0,
        eta_min_hours: 0,
        eta_max_hours: null,
        shipping_price_eur_per_bottle: 0.0,
        isSaving: false,
        isSaveAvailable: false
      });
      this.items.push(newItem);
    },
    changeToQuantityMax: function changeToQuantityMax(item) {
      item.qty_max = 2147483647;
      this.changeLogisticCost(item);
    },
    changeLogisticCost: function changeLogisticCost(item) {
      var nullishPredicate = function nullishPredicate(x) {
        return parseInt(x.qty_min) < 1 || parseInt(x.qty_min) > 2147483647 || parseInt(x.qty_max) < 1 || parseInt(x.qty_max) > 2147483647 || parseInt(x.qty_max) < parseInt(x.qty_min) || parseInt(x.eta_min_hours) < 1 || parseInt(x.eta_min_hours) > 2147483647 || x.eta_max_hours && parseInt(x.eta_max_hours) > 2147483647 || x.eta_max_hours && parseInt(x.eta_max_hours) < parseInt(x.eta_min_hours);
      };
      if (!nullishPredicate(item)) {
        item.isSaveAvailable = true;
      } else {
        item.isSaveAvailable = false;
      }
    },
    saveAll: function saveAll() {
      var _this = this;
      this.items.filter(function (x) {
        return x.isSaveAvailable;
      }).forEach(function (x) {
        _this.saveLogisticCost(x, true);
      });
    },
    saveLogisticCost: function saveLogisticCost(item) {
      var _arguments = arguments,
        _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var isCallFromSaveAll, _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              isCallFromSaveAll = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;
              item.isSaving = true;
              _this = _this7;
              if (!item.id_logistic_cost) {
                _context4.next = 8;
                break;
              }
              _context4.next = 6;
              return request("/v1/logistic/cost/".concat(item.id_logistic_cost), "put", item, true, "api").then(function (response) {
                item.isSaveAvailable = false;
                if (!isCallFromSaveAll) {
                  _this.$toasted.show("Logistic cost successfully updated.", {
                    type: "success"
                  });
                }
              }).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 6:
              _context4.next = 10;
              break;
            case 8:
              _context4.next = 10;
              return request("/v1/logistic/cost", "post", item, true, "api").then(function (response) {
                item.id_logistic_cost = +response.data.value;
                item.isSaveAvailable = false;
                if (!isCallFromSaveAll) {
                  _this.$toasted.show("Logistic cost successfully added.", {
                    type: "success"
                  });
                }
              }).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 10:
              item.isSaving = false;
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    deleteLogisticCost: function deleteLogisticCost(item) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var confirmed, _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              confirmed = true;
              if (!item.id_logistic_cost) {
                _context5.next = 9;
                break;
              }
              _context5.next = 4;
              return _this8.$refs.confirm.open("Delete", "Are you sure you want to delete this logistic cost?", {
                color: "red"
              });
            case 4:
              confirmed = _context5.sent;
              if (!confirmed) {
                _context5.next = 9;
                break;
              }
              _this = _this8;
              _context5.next = 9;
              return request("/v1/logistic/cost/".concat(item.id_logistic_cost), "delete", null, true, "api").catch(function (e) {
                confirmed = false;
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 9:
              if (confirmed) {
                _this8.items.splice(_this8.items.indexOf(item), 1);
              }
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    openScheduledLogisticCosts: function openScheduledLogisticCosts() {
      var _this9 = this;
      this.isScheduledLogisticCostsModalShown = true;
      this.$nextTick(function () {
        _this9.$refs.ScheduledLogisticCostsModal.open();
      });
    },
    closeScheduledLogisticCosts: function closeScheduledLogisticCosts() {
      this.isScheduledLogisticCostsModalShown = false;
    },
    areProfessionalsAvailable: function areProfessionalsAvailable(userGroup, first, second, third) {
      var _levelToCheck$item;
      var levelToCheck = third !== null && third !== void 0 && third.item ? third : second !== null && second !== void 0 && second.item ? second : first !== null && first !== void 0 && first.item ? first : null;
      if (levelToCheck !== null && levelToCheck !== void 0 && (_levelToCheck$item = levelToCheck.item) !== null && _levelToCheck$item !== void 0 && _levelToCheck$item.id_country_arrival) {
        if (userGroup !== "HORECA" || levelToCheck.item.id_country_arrival !== this.listCountries.find(function (x) {
          return x.iso_2 === "US";
        }).id_country) {
          return true;
        }
        return !pricePostingUsaProConstants.some(function (x) {
          return x.idState === levelToCheck.item.id_state_arrival;
        });
      } else {
        return true;
      }
    },
    fetchCountries: function fetchCountries() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this = _this10;
              _context6.next = 3;
              return request("/v1/countries/protected?implantedMarket=true&byPassLimitedLocations=true", "GET", null, true, "api").catch(function () {
                _this.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
              });
            case 3:
              response = _context6.sent;
              if (response) {
                _this10.listCountries = _toConsumableArray(response.data.countries);
                _this10.listStates = _toConsumableArray(response.data.states);
              }
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    fetchCountriesArrival: function fetchCountriesArrival() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this = _this11;
              _context7.next = 3;
              return request("/v1/countries/protected?implantedMarket=true", "GET", null, true, "api").catch(function () {
                _this.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
              });
            case 3:
              response = _context7.sent;
              if (response) {
                _this11.listCountriesArrival = _toConsumableArray(response.data.countries);
                _this11.listStatesArrival = _toConsumableArray(response.data.states);
              }
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    getSymbolCurrency: getSymbolCurrency,
    formatPrice: formatPrice
  }
};